import { CirclePile } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CirclePileIcon = createLucideIcon(CirclePile);
